<template>
 <div>
  <EditShopSubProduct ref="editShopSubProductRef"/>
  <TableStyleWrapper>
   <TableWrapper class="table-responsive">
    <a-table
     :columns="productTableColumns"
     :dataSource="productTableData"
     :loading="loadingFetchShopSubProducts"
     :pagination="{
          pageSize: tablePageSize,
          showSizeChanger: true,
          total: productsSubProducts.total,
          current: productsSubProducts.currentPage,
          showTotal: (total, range) => `${range[0]}-${range[1]} of ${productsSubProducts.total} items`,
        }"
     @change="paginationChange"
    />
   </TableWrapper>
  </TableStyleWrapper>
 </div>
</template>
<script>
import {TableStyleWrapper} from '../style';
import {TableWrapper} from '../../styled';
import {computed, defineComponent, ref} from 'vue';
import {useStore} from "vuex";
import {useRoute} from "vue-router";
import EditShopSubProduct from "@/view/product/component/EditShopSubProduct";

const ShopSubProductsTable = defineComponent({
 name: 'ShopSubProductsTable',
 components: {TableStyleWrapper, TableWrapper, EditShopSubProduct},
 setup() {
  const {state, dispatch} = useStore();
  const tablePageSize = computed(() => state.shop.productsSubProducts.pageSize);
  const {params} = useRoute();
  const editShopSubProductRef = ref();
  const loadingFetchShopSubProducts = computed(() => state.shop.loadingFetchShopSubProducts);
  const productsSubProducts = computed(() => state.shop.productsSubProducts);
  const isSustainabilityAdvanced = computed(() => state.product.product?.subType === 'SUSTAINABILITYADVANCED');

  const productSubCategories = computed(() => state.shop.productSubCategories);

  const productTableColumns = computed(() => {
   const cols = [
    { title: 'ID', dataIndex: 'id', key: 'id' },
    { title: 'Naam', dataIndex: 'name', key: 'name' },
    { title: 'Bedrag', dataIndex: 'amount', key: 'amount' },
    { title: 'Parent ID', dataIndex: 'parentID', key: 'parentID' },
    { title: 'Categorie', dataIndex: 'category', key: 'category' },
   ];
   if (isSustainabilityAdvanced.value) {
    cols.push({ title: 'Type', dataIndex: 'type', key: 'type' });
   }
   cols.push(
    { title: 'Status', dataIndex: 'active', key: 'active' },
    { title: 'Actions', dataIndex: 'action', key: 'action', width: '90px' },
   );
   return cols;
  });
  const fmt = new Intl.NumberFormat('nl-nl', {style: 'currency', currency: 'EUR'});

  const productTableData = computed(() => {
    const isAdv = isSustainabilityAdvanced.value;
    return productsSubProducts.value.data.map((product) => {
     const {id, name, imageFileURL, amount, active, parentID, isSubsidy, subCategoryID} = product;
     const indent = isAdv && parentID ? '↳ ' : '';
     const typeLabel = parentID
       ? (isSubsidy ? 'Subsidieregel' : 'Factuurregel')
       : 'Product';
     const categoryName = subCategoryID
       ? productSubCategories.value?.find(c => c.id === subCategoryID)?.name ?? '-'
       : '-';

     const row = {
      key: id,
      id: id,
      name: (
       <div class="user-info">
        <figure>
         {imageFileURL && imageFileURL !== '' ? (
          <img style={{width: '40px'}} src={`${imageFileURL}`} alt=""/>
         ) : (
          <img style={{width: '40px'}} src={require('@/static/img/users/1.png')} alt=""/>
         )}
        </figure>
        <figcaption>
         <sdHeading class="user-name" as="h6">
          {indent}{name}
         </sdHeading>
        </figcaption>
       </div>
      ),
      amount: <span style={amount < 0 ? {color: '#E30D0F'} : {}}>{fmt.format(amount)}</span>,
      parentID: parentID ?? '-',
      category: categoryName,
      active: (<span className="status-text" style={{
       color: 'white',
       backgroundColor: active ? '#0CAB7C' : '#E30D0F'
      }}>{active ? 'Actief' : 'Inactief'}</span>),
      action: (
       <div className="table-actions">
        <sdButton onClick={() => editShopSubProductRef.value.showDrawer(id)} className="btn-icon" to="#" type="default"
                  shape="circle">
         <sdFeatherIcons type="edit" size="16"/>
        </sdButton>
       </div>
      ),
     };

     if (isAdv) {
      row.type = (<span className="status-text" style={{
       color: 'white',
       backgroundColor: isSubsidy ? '#FF6B35' : parentID ? '#5B8DEF' : '#333'
      }}>{typeLabel}</span>);
     }

     return row;
    })
   }
  );

  const paginationChange = async (event) => {
   await dispatch('setShopSubProductsCurrentPage', event.current);
   await dispatch('fetchShopSubProducts', {id: params.id, page: event.current, pageSize: event.pageSize});
  }

  return {tablePageSize,
   productTableColumns,
   productTableData,
   loadingFetchShopSubProducts,
   paginationChange,
   state,
   productsSubProducts,
   editShopSubProductRef,
  };
 },
});

export default ShopSubProductsTable;
</script>
